import { IconStyling } from '@thg-commerce/gravity-patterns/Header/theme'
import { TextStyle } from '@thg-commerce/gravity-theme'

import { createPageLayoutTheme } from '../pageLayout'
import { PageLayout, Component, PartialPageLayout } from '../Renderer/layout'

interface BasketWithItems extends Component<'basketWithItems'> {
  paymentIcons: {
    order: string
    margin: {
      bottom: string
    }
  }
  continueShopping: {
    order: string
    margin: {
      bottom: string
    }
  }
}
interface SelectYourSample extends Component<'selectYourSample'> {}
interface Table extends Component<'table'> {
  icon?: IconStyling
  font: { style: TextStyle }
}
interface Referrals extends Component<'referrals'> {}
interface PaymentIcons extends Component<'paymentIcons'> {}
interface OfferSummary extends Component<'offerSummary'> {}
interface Messages extends Component<'messages'> {}
interface Discount extends Component<'discount'> {}
interface ClickAndCollectInfoModal
  extends Component<'clickAndCollectInfoModal'> {}
interface CheckoutError extends Component<'checkoutError'> {}
interface Empty extends Component<'empty'> {}

export interface BasketPageLayout
  extends PageLayout<
    | BasketWithItems
    | SelectYourSample
    | Table
    | Referrals
    | PaymentIcons
    | OfferSummary
    | Messages
    | Discount
    | ClickAndCollectInfoModal
    | CheckoutError
    | Empty
  > {}

export type PartialBasketPageLayout = PartialPageLayout<BasketPageLayout>

const { styled, useTheme } = createPageLayoutTheme<BasketPageLayout>()

export { styled, useTheme }
